/**
 * ResultsView.js
 *
 * Shows the actual movie and impostor guesses for all teams.
 */

import React from "react";
import { advanceStage } from "../helpers/stageProgressHelpers";

const ResultsView = ({ words, roomData, roomID, stage, setStage, isAdmin }) => {
    const handleNextStage = async () => {
        await advanceStage(roomID, stage, setStage);
    };

    return (
        <div className="flex flex-col items-center justify-center text-center animate-fade-in">
            <h2 className="text-2xl font-semibold mb-6 text-zinc-300">
                Results
            </h2>
            {words.map((w) => {
                const impostorGuess = roomData?.impostorGuesses?.find(
                    (g) => g.team === w.team
                );
                return (
                    <div
                        key={w.team}
                        className="mb-4 p-4 border border-zinc-600 rounded-md w-full sm:w-2/3"
                    >
                        <p className="text-lg font-semibold text-sky-400 mb-2">
                            Team {w.team}
                        </p>
                        <p className="text-zinc-300">
                            🎬 Correct Movie: <b>{w.movie}</b>
                        </p>
                        <p className="text-zinc-400 mt-1">
                            🕵️‍♂️ Impostor guessed:{" "}
                            <b>{impostorGuess?.guess || "—"}</b>
                        </p>
                    </div>
                );
            })}

            {isAdmin && (
                <button
                    onClick={handleNextStage}
                    className="mt-6 px-10 py-2 border border-white rounded-lg text-white hover:bg-white hover:text-black transition-all duration-300"
                >
                    Continue
                </button>
            )}
        </div>
    );
};

export default ResultsView;